import React from 'react';
import { Checkbox } from '@americanexpress/dls-react';
import { Link, useLocation } from 'react-router-dom';
import styles from './styles/occThankYou.scss';
import { useOCC } from './context/occContext';
import FormattedRichMessage from '../common/FormattedRichMessages';
const OCCPreferenceThankPage = () => {
  var _location$state;
  const {
    emailObj,
    savedPreferences,
    initialPreferences
  } = useOCC();

  //   if (!savedPreferences) {
  //     return <div>Loading...</div>;
  //   }
  const location = useLocation();
  const mode = (_location$state = location.state) === null || _location$state === void 0 ? void 0 : _location$state.mode;
  const displayPreferences = mode === 'cancel' ? initialPreferences : savedPreferences;
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles.occ_thankyou_container} ${styles.backgroundClr}`
  }, /*#__PURE__*/React.createElement("h2", {
    className: styles.occ_subtitle
  }, "E-MAIL SETTINGS for", ' ', emailObj === null || emailObj === void 0 ? void 0 : emailObj.maskedEmail), /*#__PURE__*/React.createElement("h3", {
    className: styles.font700
  }, mode === 'cancel' ? /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "cancelled"
  }) : /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "occPref.thankYou"
  })), /*#__PURE__*/React.createElement("p", {
    className: styles.occ_text
  }, mode === 'cancel' ? /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "occcancelOptout.subtitle"
  }) : /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "occPref.settingsSaved"
  })), /*#__PURE__*/React.createElement("h4", {
    className: styles.font700
  }, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "occPref.currentSettings"
  })), /*#__PURE__*/React.createElement("div", {
    className: styles['preferences-list']
  }, displayPreferences.map(item => /*#__PURE__*/React.createElement("div", {
    key: item.code,
    className: styles['pref-item']
  }, /*#__PURE__*/React.createElement(Checkbox, {
    id: item.code,
    checked: item.checked,
    disabled: true // 🔥 IMPORTANT
    ,
    label: item.title
  })))), /*#__PURE__*/React.createElement("div", {
    className: styles['footer-text']
  }, /*#__PURE__*/React.createElement("p", {
    className: styles.occ_text
  }, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "occcancelOptout.Ul"
  })), /*#__PURE__*/React.createElement("ul", {
    className: styles.occ_list
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "occcancelOptout.note1"
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "occcancelOptout.note2"
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "occcancelOptout.note3"
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.occ_links
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/email-security"
  }, /*#__PURE__*/React.createElement(FormattedRichMessage, {
    id: "occcancelOptout.linkText"
  })))));
};
export default OCCPreferenceThankPage;